/**
 * How long a package lasts, written the same way on the website, the quotation,
 * and every message that goes to a client.
 * Keep in step with server/packageDuration.js.
 */
export function formatPackageDuration(value?: number | null): string {
  const minutes = Math.round(Number(value));
  if (!Number.isFinite(minutes) || minutes <= 0) return '';
  const known: Record<number, string> = {
    15: '¼ hour',
    30: '½ hour',
    45: '¾ hour',
    90: '1½ hours',
    150: '2½ hours',
    210: '3½ hours',
    270: '4½ hours',
    330: '5½ hours',
    390: '6½ hours',
    450: '7½ hours',
    510: '8½ hours',
  };
  if (known[minutes]) return known[minutes];
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (hours > 0 && remainder === 0) return hours === 1 ? '1 hour' : `${hours} hours`;
  if (hours === 0) return remainder === 1 ? '1 minute' : `${remainder} minutes`;
  const hourLabel = hours === 1 ? '1 hour' : `${hours} hours`;
  const minuteLabel = remainder === 1 ? '1 minute' : `${remainder} minutes`;
  return `${hourLabel} ${minuteLabel}`;
}

export function quotePackageDuration(quote?: {
  sessions?: Array<{ durationMinutes?: number }> | null;
  snapshot?: { lines?: Array<{ kind?: string; durationMinutes?: number }> } | null;
} | null): number {
  const sessions = quote?.sessions || [];
  if (sessions.length > 0) {
    return sessions.reduce((sum, session) => {
      const minutes = Number(session.durationMinutes);
      return sum + (Number.isFinite(minutes) && minutes > 0 ? Math.round(minutes) : 0);
    }, 0);
  }
  const lines = quote?.snapshot?.lines || [];
  const sessionMinutes = lines
    .filter((item) => item?.kind === 'session' && Number(item.durationMinutes) > 0)
    .reduce((sum, item) => sum + Math.round(Number(item.durationMinutes)), 0);
  if (sessionMinutes > 0) return sessionMinutes;
  const line = lines.find((item) => item?.kind === 'package' && Number(item.durationMinutes) > 0);
  return line ? Math.round(Number(line.durationMinutes)) : 0;
}
